<div
  class="container"
  [class.local]="local">
  <importer-app-turbine
    speed="fast"
    [contrast]="contrast"></importer-app-turbine>
  <importer-app-turbine
    [text]="true"
    [contrast]="contrast"></importer-app-turbine>
  <importer-app-turbine
    speed="slow"
    [contrast]="contrast"></importer-app-turbine>
</div>
